import React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"
import { useMemberProgramFlags } from "#/services/user/hooks/useMemberProgram"
import { PageLoading } from "#/features/global-ui/page-layout"

// Route wrapper for pages that only apply to enterprise (non-consumer) members —
// consumers get bounced to the home page. Mirrors LockedDownRoute in shape so it
// slots into the App.tsx Switch's `allowedRouters` list the same way.
export function EnterpriseOnlyRoute(props: RouteProps): JSX.Element {
  const { data: programFlags, isLoading, isError } = useMemberProgramFlags()
  if (isLoading || isError || !programFlags) return <PageLoading />
  if (programFlags.isConsumer) return <Redirect to="/" />
  return <Route {...props} />
}
